import { CONFIG } from './config'

export const WORDS = [
'ɹæɪdiːəʉ',
'toːkɪŋ',
'æɔtsɑed',
'fɹend',
'wɪðæɔt',
'pɜːpəs',
'membə',
'wɪmən',
'tʃeːmən',
'ɹiːsnt',
'ɹəmæɪn',
'plænz',
'kɔsts',
'jʊəɹəp',
'mɪstə',
'bəkɐm',
'wæɪtɪŋ',
'mæɪkɪŋ',
'bæɪsɪk',
'tʃæɪndʒd',
'tæɪkən',
'foːwəd',
'bæɪsəs',
'θæɔznd',
'bəgæn',
'lɑekliː',
'sɪŋgl',
'kæɹiːd',
'sɪəɹiːz',
'pɹeʃə',
'kæɔnsl',
'hævɪŋ',
'vɪlɪdʒ',
'wɔnts',
'stɐdiː',
'ɐntɪl',
'wɜːkɪŋ',
'ɹətɜːn',
'sekʃn',
'ɹəpoːt',
'fɔləʉz',
'tɹɑeɪŋ',
'fɪgəz',
'stæɪʃn',
'mɪsəz',
'əmæɔnt',
'pɪktʃə',
'tiːtʃəz',
'nɐθɪŋ',
'mʉːvɪŋ',
'dəzɑen',
'ɔfəsə',
'enədʒiː',
'ækses',
'gɪvɪŋ',
'əkæɔnt',
'hændz',
'θɹʉːæɔt',
'moːnɪŋ',
'wʊmən',
'jʉːnət',
'əʉldəɹ',
'stɹiːt',
'spent',
'ɹiːdʒən',
'kɔmən',
'sɪvəl',
'dəgɹiː',
'stɔpt',
'ɪndiːd',
'liːvɪŋ',
'klɪəliː',
'səpəʉz',
'plæɪɪŋ',
'ənles',
'ɹiːsɜːtʃ',
'levlz',
'əkɹɔs',
'sɜːvəs',
'dʒɜːmən',
'kɔlɪdʒ',
'pæɔndz',
'həʉtel',
'sɪmpl',
'dɔktə',
'stænd',
'piːtəɹ',
'fɹɐːns',
'sɜːfəs',
'nɐmbə',
'bəliːv',
'bəfoːɹ',
'ɹɐnɪŋ',
'wɪndəʉ',
'mɐːkət',
'ɹekoːd',
'væljʉː',
'hæɔzəz',
'fɔɹən',
'tɹɐbl',
'wɪðɪn',
'stoːɹiː',
'fɔləʉd',
'skɪlz',
'səpoːt',
'kɐmɪŋ',
'ɹəkoːd',
'mɪlɪən',
'əfekt',
'oːlwæɪz',
'bɹɪtn',
'getɪŋ',
'fɹentʃ',
'fjʉːtʃə',
'sentə',
'ədvɑes',
'gɹæɔnd',
'əvent',
'əgɹiːd',
'meiːdʒə',
'miːtɪŋ',
'kæɔntiː',
'əɹæɔnd',
'pəliːs',
'æɪpɹəl',
'sektə',
'nekst',
'iːzəliː',
'gɹæɪtə',
'ənɐðə',
'tæɪkɪŋ',
'dəziːz',
'stɹɔŋ',
'sɐndæɪ',
'enʃʊəɹ',
'bəkæɪm',
'hæɔevə',
'mɐnθs',
'meθəd',
'foːsəz',
'lʊkɪŋ',
'əɹɑevd',
'səʉvɪət',
'poɪnts',
'əpɹəʉtʃ',
'speʃl',
'pɐːtiːz',
'skʉːlz',
'jʉːzɪŋ',
'ɹiːzən',
'nɔlɪdʒ',
'kæɪsəz',
'iːvnɪŋ',
'sɑeəns',
'niːdəd',
'hɐːdliː',
'əʉpənd',
'tʃæptə',
'wɜːkəz',
'gɹʉːps',
'eniːwæɪ',
'ɪŋkɐm'
]

if (CONFIG.normalization) {
  WORDS.forEach((val, i) => (WORDS[i] = val.normalize(CONFIG.normalization)))
}

function shuffle(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
}

if (CONFIG.shuffle) {
  shuffle(WORDS)
}
